<template>
    <div class="my-jl">
        <div style="width: 95%;margin: auto">
            <van-cell-group custom-class="goods-cell-group" v-for=" item in items">
                <van-cell @click="to(item)" is-link>
                    <van-icon :class="'iconfont '+ item.tmIcon" size="16" style="color: #2b94ff;margin-right: 8px"/>
                    <span style="font-size: 12px">{{item.menuName}}</span>
                </van-cell>
            </van-cell-group>
        </div>
    </div>
</template>
<script>
    import {getDeptId} from "../../../utils/auth";

    export default {
        components: {
        },
        data() {
            return {
                deptId: '',
                phone: '',
                bps: [],
                ysItem: {},
                items: [],
            };
        },
        props: {
            item: Object
        },
        async created() {
            this.ysItem = this.item
            this.deptId = getDeptId()
            this.getStyleMenus()
        },
        methods: {
            async getStyleMenus() {
                let data = {
                    deptId: this.deptId,
                    styleId: this.ysItem.id,
                }
                let res = await this.$get("/spm/getSpmStyleMenus", data)
                this.items = res.list
            },
            to(item){
                if (item.route=='wkf'){
                    this.$notify({
                        message: '此功能正在开发',
                        duration: 1000,
                        background: 'red'
                    });
                    return;
                }
                this.$router.push(item.route+'/' + this.deptId)
            },
        },
    };
</script>

<style lang="scss" scoped>

    .my-jl {
        background-color: #FFFFFF;
        margin: 8px;
        border-radius: 5px;
    }

    .jl-list {
        width: 95%;
        margin: auto;
        height: 80px;
        padding-top: 18px;
    }

    ::v-deep .van-cell {
        position: relative;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        box-sizing: border-box;
        width: 100%;
        padding: 8px 3px;
        overflow: hidden;
        color: #323233;
        font-size: 0.37333rem;
        line-height: 0.61rem;
        background-color: #fff;
    }


</style>
